module.exports = __webpack_public_path__ + "static/portrait.abd1036a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portrait.jpg
// module id = 130
// module chunks = 35783957827783 117800764950200